import { render, staticRenderFns } from "./AffiliateInvitation.vue?vue&type=template&id=a493b27e&scoped=true&"
import script from "./AffiliateInvitation.vue?vue&type=script&lang=js&"
export * from "./AffiliateInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateInvitation.vue?vue&type=style&index=0&id=a493b27e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a493b27e",
  null
  
)

export default component.exports